import React, { useState, useEffect } from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Press from './components/Press';
import Educator from './components/Educator';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Resume from './components/Resume';

function getPage() {
  return window.location.hash === '#resume' ? 'resume' : 'main';
}

function App() {
  const [page, setPage] = useState(getPage);

  useEffect(() => {
    const onHash = () => {
      const next = getPage();
      setPage(prev => {
        if (next !== prev) window.scrollTo(0, 0);
        return next;
      });
    };
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  if (page === 'resume') {
    return <Resume />;
  }

  return (
    <div className="App">
      <Navbar />
      <main>
        <section id="home" style={{ height: '100vh', overflow: 'hidden' }}>
          <Hero />
        </section>
        <div className="divider" />
        <section id="work">
          <Portfolio />
        </section>
        <div className="divider" />
        <section id="about">
          <About />
        </section>
        <div className="divider" />
        <section id="press">
          <Press />
        </section>
        <div className="divider" />
        <section id="educator">
          <Educator />
        </section>
        <div className="divider" />
        <section id="contact">
          <Contact />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default App;